import { render, staticRenderFns } from "./paycenterPage.vue?vue&type=template&id=4760d39b&scoped=true&"
import script from "./paycenterPage.vue?vue&type=script&lang=js&"
export * from "./paycenterPage.vue?vue&type=script&lang=js&"
import style0 from "./paycenterPage.vue?vue&type=style&index=0&id=4760d39b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4760d39b",
  null
  
)

export default component.exports